import { render, staticRenderFns } from "./robyg-form.vue?vue&type=template&id=8283fcb8&scoped=true&"
import script from "./robyg-form.vue?vue&type=script&lang=js&"
export * from "./robyg-form.vue?vue&type=script&lang=js&"
import style0 from "./robyg-form.vue?vue&type=style&index=0&id=8283fcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8283fcb8",
  null
  
)

export default component.exports